<template>
  <div>
    <div align="left">
      <br />
      <h5 class="h5 text-primary">
        <b>Online Test</b>
      </h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Test</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Test Name" label-for="input-1">
            <b-form-input v-model="test_name" placeholder="Title"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Duration" label-for="input-1">
            <b-form-input type="number" v-model="duration" placeholder="In minutes"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Test Title (Bahasa)" label-for="input-1">
            <b-form-input id="input-1" v-model="title_id" placeholder="Title In Bahasa Indonesia"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="fieldset-1" label="Test Title (English)" label-for="input-1">
            <b-form-input v-model="title_en" placeholder="Title In English"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Test Introduction (Bahasa)" label-for="input-1">
            <ckeditor
              :editor="editor"
              v-model="introduction_id"
              tag-name="textarea"
              placeholder="Test Introduction In Bahasa Indonesia"
              name="answer_en"
              class="form-control"
              :config="editorConfig"
            ></ckeditor>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="fieldset-1" label="Test Introduction (English)" label-for="input-1">
            <ckeditor
              :editor="editor"
              tag-name="textarea"
              v-model="introduction_en"
              placeholder="Test Introduction In English"
              name="answer_en"
              class="form-control"
              :config="editorConfig"
            ></ckeditor>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-left">
          <b-form-group id="fieldset-1" label="Auto Grading" label-for="input-1">
            <b-form-radio-group
              id="radio-group-1"
              v-model="is_auto_grading"
              :options="options2"
              name="radio-options"
              @change="ChangeGrading(is_auto_grading)"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col v-show="is_auto_grading === true">
          Total Score
          <br />
          <p class="pt-2">{{total()}}</p>
        </b-col>
      </b-row>
      <hr />
      <div v-for="(input , k) in test" :key="k">
        <b-row>
          <b-col class="text-left">
            <h5>Question {{k+1}}</h5>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-form-group id="fieldset-1" label="Question (Bahasa)" label-for="input-1">
              <b-form-textarea
                id="textarea"
                v-model="input.question_bahasa"
                placeholder="Question In Bahasa"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="fieldset-1" label="Question (English)" label-for="input-1">
              <b-form-textarea
                id="textarea"
                v-model="input.question_enlish"
                placeholder="Question In Bahasa English"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col md="6">
            <b-form-group id="fieldset-1" label="Supporting File" label-for="input-1"></b-form-group>
            <b-card body-class="py-2 px-2">
              <card-body>
                <b-row>
                  <b-col md="8" class="text-primary mt-2">
                    <i class="fas fa-paperclip"></i>
                    &nbsp;
                    File {{!test[k].support_file ? 'Photo':test[k].support_file.name}} (.doc/.xls/.pdf/.png/.jpg)
                    <sup
                      class="text-secondary pl-3 mr-5 pr-5"
                    >(2 Mb)</sup>
                  </b-col>
                  <b-col class="text-right" align="right">
                    <input
                      type="file"
                      ref="datas"
                      style="display: none"
                      v-on:change="onChangeimage(k)"
                    />
                    <b-button
                      @click="$refs.datas[k].click()"
                      v-show="!test[k].support_file "
                      variant="primary"
                      class="ml-5"
                    >Select File</b-button>
                    <b-button
                      @click="$refs.datas[k].click()"
                      v-show="test[k].support_file "
                      variant="outline-primary"
                      class
                    >Change File</b-button>
                  </b-col>
                </b-row>
              </card-body>
            </b-card>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col md="6">
            <b-form-group id="fieldset-1" label="Answer Type" label-for="input-1"></b-form-group>
            <b-form-select v-model="input.answer_type" class="mb-3">
              <template slot="first">
                <option :value="null" disabled>Select Answer Type</option>
                <option value="short_answer">Short Answer</option>
                <option
                  value="essay_answer"
                  :class="is_auto_grading == true ?'text-danger':''"
                  :disabled="is_auto_grading == true"
                >Essay</option>
                <option value="multiple_choice">Multiple Choice</option>
                <option value="checkboxes">Checkboxes</option>
                <option
                  value="file_upload_answer"
                  :class="is_auto_grading == true ?'text-danger':''"
                  :disabled="is_auto_grading == true"
                >File Upload</option>
              </template>
            </b-form-select>
          </b-col>
          <b-col v-show="is_auto_grading === true">
            <b-form-group id="fieldset-1" label="Points" label-for="input-1"></b-form-group>
            <b-form-input
              type="number"
              v-model="input.points"
              placeholder="Point For Score (numbers only)"
            ></b-form-input>
          </b-col>
        </b-row>
        <div v-show="input.answer_type === 'short_answer'">
          <b-row>
            <b-col md="6">
              <b-form-group id="fieldset-1" label-for="input-1">Answer</b-form-group>
              <b-form-input v-model="input.short_answer" placeholder="Exact answer"></b-form-input>
            </b-col>
          </b-row>
        </div>
        <div v-show="input.answer_type === 'essay_answer'">
          <b-row>
            <b-col md="6">
              <b-form-group id="fieldset-1" label-for="input-1">Answer</b-form-group>
              <b-form-textarea
                id="textarea"
                v-model="input.essay_answer"
                placeholder="Essay Answer"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-col>
          </b-row>
        </div>
        <div
          v-show="input.answer_type === 'multiple_choice'"
          v-for="(answer,l) in input.multiple_choice.answer_choice"
          :key="l"
        >
          <b-row>
            <b-col>
              <b-form-group id="fieldset-1" label-for="input-1">Choice {{l+1}}</b-form-group>
              <b-form-input v-model="answer.id" placeholder="Choice in Bahasa"></b-form-input>
            </b-col>
            <b-col class="text-right">
              <b-form-group id="fieldset-1" label-for="input-1">
                <b-form-radio-group
                  v-model="input.multiple_choice.correct_answer"
                  :name="'radio-inline'+k"
                >
                  <b-form-radio :value="l">Correct Choice</b-form-radio>
                  <b-link
                    style="text-decoration:none;"
                    @click="remove_multiple(l,k)"
                    v-show="l || ( !l && test[k].multiple_choice.answer_choice.length > 1)"
                    class="text-danger"
                  >Remove</b-link>
                </b-form-radio-group>
              </b-form-group>
              <b-form-input v-model="answer.en" placeholder="Choice in English"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <b-button
                @click="add_multiple(l,k)"
                v-show="l == test[k].multiple_choice.answer_choice.length-1"
                variant="outline-primary"
              >
                <i class="fas fa-plus"></i> Add more choice
              </b-button>
            </b-col>
          </b-row>
        </div>
        <div
          v-show="input.answer_type === 'checkboxes'"
          v-for="(answer,l) in input.checkbox.answer_choice"
          :key="l"
        >
          <b-row>
            <b-col>
              <b-form-group id="fieldset-1" label-for="input-1">Checkbox {{l+1}}</b-form-group>
              <b-form-input placeholder="Choice in Bahasa" v-model="answer.id"></b-form-input>
            </b-col>
            <b-col class="text-right">
              <b-form-group id="fieldset-1" label-for="input-1">
                <b-form-checkbox-group
                  id="checkbox-group-2"
                  v-model="input.checkbox.correct_answer"
                  name="flavour-2"
                >
                  <b-form-checkbox :value="l">
                    Correct Choice &nbsp;
                    <b-link
                      @click="remove_checkbox(l,k)"
                      v-show="l || ( !l && test[k].checkbox.answer_choice.length > 1)"
                      style="text-decoration:none;"
                      class="text-danger"
                    >Remove</b-link>
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
              <b-form-input placeholder="Choice in English" v-model="answer.en"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <b-button
                @click="add_checkbox(l,k)"
                v-show="l == test[k].checkbox.answer_choice.length-1"
                variant="outline-primary"
              >
                <i class="fas fa-plus"></i> Add more choice
              </b-button>
            </b-col>
          </b-row>
        </div>
        <div v-show="input.answer_type === 'file_upload_answer'">
          <b-row>
            <b-col md="6">
              <b-form-group id="fieldset-1" label-for="input-1">Answer File</b-form-group>
              <b-form-file
                v-model="input.file_upload_answer"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              ></b-form-file>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col></b-col>
          <b-col md="3" class="text-right">
            <b-button
              block
              variant="danger"
              @click="remove(k)"
              v-show="k || ( !k && test.length > 1)"
            >Remove Question</b-button>
          </b-col>
        </b-row>

        <hr />
        <b-row>
          <b-col md="3"></b-col>
          <b-col>
            <b-button
              block
              variant="warning"
              @click="add(k)"
              v-show="k == test.length-1"
            >Add More Question</b-button>
          </b-col>
        </b-row>
      </div>
      <b-button variant="primary" @click="post()" class="mr-3">Save</b-button>
      <router-link :to="{name: 'pxOnlineTest'}">
        <b-button variant="outline-secondary">Cancel</b-button>
      </router-link>
    </b-card>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          'fontSize',
          '|',
          'bold',
          'italic',
          'underline',
          'fontColor',
          '|',
          'alignment',
          'bulletedList',
          'numberedList',
          'outdent',
          'indent',
          'link',
          '|',
          'strikethrough',
        ],
      },
      selected: null,
      is_auto_grading: null,
      file_upload_answer: null,
      image: null,
      urlImage: null,
      options2: [
        { value: false, text: 'No' },
        { value: true, text: 'Yes' },
      ],
      total_point: 0,
      test_name: null,
      duration: null,
      title_id: null,
      title_en: null,
      introduction_id: null,
      introduction_en: null,
      test: [
        {
          question_bahasa: null,
          question_enlish: null,
          support_file: null,
          answer_type: null,
          points: 0,
          short_answer: null,
          essay_answer: null,
          file_upload_answer: null,
          multiple_choice: {
            correct_answer: null,
            answer_choice: [
              {
                id: null,
                en: null,
              },
            ],
          },
          checkbox: {
            correct_answer: [],
            answer_choice: [
              {
                id: null,
                en: null,
              },
            ],
          },
        },
      ],
    };
  },
  mounted() {
    this.$refs.datas.addEventListener('click', (e) => {
      console.log('clicked: ', e.target);
    });
  },
  computed: {
    total_points() {},
  },
  methods: {
    onChangeimage(id) {
      this.test[id].support_file = this.$refs.datas[id].files[0];
      // this.$refs.datas[id].click();
      // console.log(this.$refs.datas[0]);
    },
    post() {
      const formData = new FormData();
      formData.append('test_name', this.test_name);
      formData.append('duration', this.duration);
      formData.append('title_id', this.title_id);
      formData.append('title_en', this.title_en);
      formData.append('introduction_id', this.introduction_id);
      formData.append('introduction_en', this.introduction_en);
      formData.append('is_auto_grading', this.is_auto_grading);
      if (this.test) {
        $.each(this.test, (index, value) => {
          formData.append('question_and_answers[sequence]', index);
          formData.append(
            `question_and_answers[answer_type][${index}]`,
            value.answer_type,
          );
          formData.append(
            `question_and_answers[question_id][${index}]`,
            value.question_bahasa,
          );
          formData.append(
            `question_and_answers[question_en][${index}]`,
            value.question_enlish,
          );
          formData.append(
            `question_and_answers[supporting_file][${index}]`,
            value.support_file,
          );
          formData.append(
            `question_and_answers[point][${index}]`,
            value.points,
          );
          if (value.answer_type == 'multiple_choice') {
            formData.append(
              `question_and_answers[correct_answers][${index}]`,
              value.multiple_choice.correct_answer,
            );
            $.each(value.multiple_choice.answer_choice, (key, choice) => {
              console.log(choice);
              formData.append(
                `question_and_answers[${
                  value.answer_type
                }][${
                  index
                }][sequence]`,
                key,
              );
              formData.append(
                `question_and_answers[${
                  value.answer_type
                }][${
                  index
                }][choice_id][${
                  key
                }]`,
                choice.id,
              );
              formData.append(
                `question_and_answers[${
                  value.answer_type
                }][${
                  index
                }][choice_en][${
                  key
                }]`,
                choice.en,
              );
            });
          }
          if (value.answer_type == 'checkbox') {
            formData.append(
              `question_and_answers[correct_answers][${index}]`,
              value.checkbox.correct_answer,
            );
            $.each(value.checkbox.answer_choice, (key, choice) => {
              formData.append(
                `question_and_answers[${
                  value.answer_type
                }][${
                  index
                }][sequence]`,
                key,
              );
              formData.append(
                `question_and_answers[${
                  value.answer_type
                }][${
                  index
                }][choice_id][${
                  key
                }]`,
                choice.answer_choice.id,
              );
              formData.append(
                `question_and_answers]${
                  value.answer_type
                }][${
                  index
                }][choice_en][${
                  key
                }]`,
                choice.answer_choice.en,
              );
            });
          }
          if (value.answer_type == 'essay_answer') {
            formData.append(
              `question_and_answers[${value.answer_type}][${index}]`,
              value.essay_answer,
            );
          }
          if (value.answer_type == 'short_answer') {
            formData.append(
              `question_and_answers[${value.answer_type}][${index}]`,
              value.short_answer,
            );
          }
          if (value.answer_type == 'file_upload_answer') {
            formData.append(
              `question_and_answers[${value.answer_type}][${index}]`,
              value.file_upload_answer,
            );
          }
        });
      }

      this.loading = true;
      this.$store
        .dispatch('onlineTestModule/postOnlineTest', formData)
        .then((response) => {
          this.loading = false;
          this.$router.push({ name: 'pxOnlineTest' });
          this.$swal({
            type: 'success',
            title: 'Your work has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(response);
        })
        .catch((error) => {
          this.loading = false;
          this.serverError = error.response.data;
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(error);
        });
    },
    total() {
      let total = 0;
      for (let i = 0; i < this.test.length; i++) {
        total += parseInt(this.test[i].points);
      }
      return total;
    },
    add(index) {
      this.test.push({
        question_bahasa: null,
        question_enlish: null,
        support_file: null,
        answer_type: null,
        points: 0,
        short_answer: null,
        essay_answer: null,
        file_upload_answer: null,
        multiple_choice: {
          correct_answer: null,
          answer_choice: [
            {
              id: null,
              en: null,
            },
          ],
        },
        checkbox: {
          correct_answer: [],
          answer_choice: [
            {
              id: null,
              en: null,
            },
          ],
        },
      });
    },
    ChangeGrading(data) {
      this.$swal({
        title: 'Are you sure?',
        text: 'All your data input will reset',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, change it!',
      }).then((result) => {
        if (result.value) {
          this.test = [
            {
              question_bahasa: null,
              question_enlish: null,
              support_file: null,
              answer_type: null,
              points: 0,
              short_answer: null,
              essay_answer: null,
              file_upload_answer: null,
              multiple_choice: {
                correct_answer: null,
                answer_choice: [
                  {
                    id: null,
                    en: null,
                  },
                ],
              },
              checkbox: {
                correct_answer: [],
                answer_choice: [
                  {
                    id: null,
                    en: null,
                  },
                ],
              },
            },
          ];
          this.$swal('Change!', 'Your data input has been reset.', 'success');
        }
      });
    },
    remove(index) {
      this.test.splice(index, 1);
    },
    add_multiple(choice, index) {
      this.test[index].multiple_choice.answer_choice.push({
        id: null,
        en: null,
      });
    },
    remove_multiple(choice, index) {
      this.test[index].multiple_choice.answer_choice.splice(choice, 1);
    },
    add_checkbox(choice, index) {
      this.test[index].checkbox.answer_choice.push({
        id: null,
        en: null,
      });
    },
    remove_checkbox(choice, index) {
      this.test[index].checkbox.answer_choice.splice(choice, 1);
    },
    radio(key) {
      // $(".radio-value").val("salah");
      $('.radio-value').each(function () {
        $(this).val('salah');
        alert($(this).val());
      });
      $(`#radio-value${key}`).val('benar');
      // $("input[name='customRadioInline1']").val("true");
      // $("#radio-coy" + key).val(true);
    },
  },
};
</script>

<style>
</style>
